import React from 'react';
import { Link } from 'react-router-dom';
import TableHead from './TableHead';
import TableRow from './TableRow';

class PopupFooter extends React.Component {
    handlePopup(url, fields, footer, id) {
        this.setState({
            modalIsOpen: true,
            modalUrl: url,
            modalFields: fields,
            modalFooter: footer,
            modalId: id
        });
    }
    render() {
        if (this.props.footer === undefined)
            return null;

        return (
            <div>
                {
                    this.props.footer.map(function (row, i) {
                        // condition check
                        if (row.condition !== undefined) {
                            if (this.props.data[row.condition.field] !==  row.condition.value) {
                                return null;
                            }
                        }
                        // type check
                        if (row.type === 'button') {
                            var url = row.url;
                            row.urlattrs.map(function (attr, k) {
                                url = url.replace('$' + attr.key, this.props.data[attr.value]);
                            }, this);
                            return (
                                <div key={i}><Link className="btn btn-view" to={ url }>{ row.value }</Link></div>
                            )
                        } else if (row.type === 'table')  {
                            var data = this.props.data[row.source];
                            if (data === undefined)
                                return null;
                            return(
                                <div key={ i }>
                                    <h5>{ row.title }</h5>
                                    <table id={ i } className='table table-bordered table-striped'>
                                        <TableHead columns={ row.fields }/>
                                        <tbody>
                                        {
                                            data.map(function(datarow, i) {
                                                return (
                                                    <TableRow
                                                        key={ i }
                                                        id={ i }
                                                        row={ datarow }
                                                        metadata={ row.fields }
                                                        handlePopup = { this.handlePopup.bind(this) }
                                                    />
                                                )
                                            }, this)
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            )
                        }
                    }, this)
                }
            </div>
        )
    }
}

export default PopupFooter;